export default __webpack_public_path__ + "static/christensen-6b428024bfb1b8ae591bd3b6090ca1ea.jpg";